<template>
	<div class="row" style="padding: 30px">
		<div class="col-12" v-if="success">
			<div class="row" style="margin-top: 175px">
				<div class="col-12 center">
					<h2 class="teal-text">Success!</h2>
					<p>The booking has been registered. See you at the office!</p>
					<button
						@click="closeModal"
						@touchstart.prevent="closeModal"
						style="margin-top: 20px"
						class="waves-effect waves-light teal btn-small btn-block"
					>
						Close
					</button>
				</div>
			</div>
		</div>
		<div class="col-12" v-if="!success">
			<div class="row">
				<div class="col-12">
					<h5>Make a Booking | Office {{ selectedOffice.naam }}</h5>
				</div>
			</div>
			<div class="row margin-top-30">
				<div class="col-12">
					<h5 class="teal-text">{{ day }}</h5>
					<p class="grey-text">{{ time }}</p>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<label for="">Name Employee</label>
					<input type="text" v-model="name_employee" :disabled="true" />
				</div>
			</div>
			<div class="row" v-if="parkingBooking">
				<div class="col-12">
					<label for="">License Plate Number</label>
					<input type="text" v-model="license_plate" />
				</div>
			</div>
			<!-- <div class="row" v-if="!parkingBooking">
                <div class="col-12 input-field">
                    <textarea  style="height: 130px;" v-model="why" class="materialize-textarea" id="text-area-why" maxlength="200"></textarea>
                    <label for="text-area-why">Voor wie?</label>
                </div>
            </div> -->
			<div class="row margin-top-30">
				<div class="col-12">
					<div class="row center">
						<div class="col m4">
							<button
								type="button"
								class="waves-effect waves-light btn btn-block"
								:class="{ grey: shift != 1 }"
								@click.prevent="shift = 1"
								@touchstart.prevent="shift = 1"
								:disabled="disabled_day"
							>
								Whole Day
							</button>
						</div>
						<div class="col m4">
							<button
								type="button"
								class="waves-effect waves-light btn btn-block"
								:class="{ grey: shift != 2 }"
								@click.prevent="shift = 2"
								@touchstart.prevent="shift = 2"
								:disabled="disabled_morning"
							>
								Morning
							</button>
						</div>
						<div class="col m4">
							<button
								type="button"
								class="waves-effect waves-light btn btn-block"
								:class="{ grey: shift != 3 }"
								@click.prevent="shift = 3"
								@touchstart.prevent="shift = 3"
								:disabled="disabled_afternoon"
							>
								Afternoon
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="row margin-top-30">
				<div class="col-12 center">
					<a
						class="waves-effect waves-light btn"
						@touchstart.prevent="confirmBooking()"
						@click="confirmBooking()"
						>Confirm Request</a
					>
				</div>
			</div>
			<div class="row" v-if="feedback">
				<div class="col-12">
					<p class="red-text">{{ feedback }}</p>
				</div>
			</div>
			<div class="row" v-if="!feedback && disabled_afternoon">
				<div class="col-12">
					<p class="red-text">
						You already have a booking on this day in the afternoon
					</p>
				</div>
			</div>
			<div class="row" v-if="!feedback && disabled_morning">
				<div class="col-12">
					<p class="red-text">
						You already have a booking on this day in the Morning
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import requestBooking from "@/components/modals/requestBooking";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import firebase from "firebase";
export default {
	name: "addBooking",
	data() {
		return {
			name_employee: null,
			email_employee: null,
			time: null,
			day: null,
			feedback: null,
			success: false,
			user: null,
			shift: null,
			disabled_day: false,
			disabled_afternoon: false,
			disabled_morning: false,
			license_plate: null,
			why: null,
            date_string: null,
		};
	},
	props: ["office_id", "timestamp", "shifts_possible"],
	computed: {
		...mapGetters(["selectedOffice"]),
	},
	methods: {
		...mapActions(["requestBooking"]),
        generateRandomId(length) {
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * characters.length));
            }
            return result;
        },
		confirmBooking() {

            var randomIdString = this.generateRandomId(8)

			if (
				this.parkingBooking &&
				(!this.license_plate || this.license_plate.length < 5)
			) {
				this.feedback =
					"You must provide a valid license plate number. You can also add your license plate number to your profile.";
				return;
			}
			if (this.name_employee && this.shift) {
				let info = {
					officeid: this.office_id,
					employee: this.name_employee,
					timestamp: this.timestamp,
					location: this.selectedOffice.naam,
					license_plate: this.license_plate,
					shift: this.shift,
                    date_string: this.date_string,
                    groupID: randomIdString,
					// reason: this.why
				};
				this.requestBooking(info);
				this.success = true;
			} else {
				this.feedback = "You must provide a name and shift.";
			}
		},
		containsParkeren() {
			if (
				this.selectedOffice &&
				typeof this.selectedOffice.naam &&
				typeof this.selectedOffice.naam === "string"
			) {
				return this.selectedOffice.naam.toLowerCase().includes("parkeren");
			}
			return false;
		},
		closeModal() {
			this.$emit("close");
		},
	},
	created() {
		this.shift = this.shifts_possible;
		if (this.shifts_possible == 3) {
			this.disabled_day = true;
			this.disabled_morning = true;
		} else if (this.shifts_possible == 2) {
			this.disabled_day = true;
			this.disabled_afternoon = true;
		}
		this.time = moment(this.timestamp).format("Do MMM");
		this.day = moment(this.timestamp).format("dddd");
		this.user = firebase.auth().currentUser;
        this.date_string = moment(this.timestamp).format("DD-MM-YYYY");

		this.name_employee = this.user.displayName;
		this.license_plate = this.user.photoURL;

		this.parkingBooking = this.containsParkeren();
	},
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/modals/requestBooking.vue